'use client';

import { useEffect, useState } from 'react';
import { Col, Form, InputNumber, Space } from 'antd';
import SelectAnimalBreed from '../../../components/selects/SelectAnimalBreed';
import SelectAnimalType from '../../../components/selects/SelectAnimalType';
import { Row } from 'antd/lib';
import { useTranslation } from "react-i18next";

type Animal = {
    id: number;
    type_id: number | null; // ID вида
    breed_id: number | null; // ID породы
    count: number | null; // Количество
};

type Props = {
    setAnimalData: any; // Функция для передачи данных
    initialAnimals?: Animal[]; // Начальные данные животных (опционально)
};

export default function AddAnimals(props: Props) {
    const { t } = useTranslation();
    const [animals, setAnimals] = useState<Animal[]>([
        {
            id: 1,
            type_id: null,
            breed_id: null,
            count: null,
        },
    ]);

    useEffect(() => {
        if (props.initialAnimals && props.initialAnimals.length > 0) {
            const initialData = props.initialAnimals.map((animal, index) => ({
                ...animal,
                id: index + 1,
            }));
            setAnimals(initialData);
        }
    }, [props.initialAnimals]);

    const handleTypeChange = (id: number, type_id: number) => {
        setAnimals((prevAnimals) =>
            prevAnimals.map((animal) =>
                animal.id === id
                    ? { ...animal, type_id, breed_id: null } // Сбрасываем породу при изменении вида
                    : animal
            )
        );
    };

    const handleBreedChange = (id: number, breed_id: number) => {
        setAnimals((prevAnimals) =>
            prevAnimals.map((animal) =>
                animal.id === id ? { ...animal, breed_id } : animal
            )
        );
    };

    const handleCountChange = (id: number, count: number) => {
        setAnimals((prevAnimals) =>
            prevAnimals.map((animal) =>
                animal.id === id ? { ...animal, count } : animal
            )
        );
    };

    const addAnimal = () => {
        setAnimals([
            ...animals,
            {
                id: animals.length + 1,
                type_id: null,
                breed_id: null,
                count: null,
            },
        ]);
    };

    const removeAnimal = (id: number) => {
        setAnimals(animals.filter((animal) => animal.id !== id));
    };

    useEffect(() => {
        const validAnimals = animals.filter(
            (animal) =>
                animal.type_id !== null &&
                animal.breed_id !== null &&
                animal.count !== null
        );
        props.setAnimalData(validAnimals);
    }, [animals]);

    return (
        <>
            {animals.map((animal) => (
                <Row gutter={10} key={animal.id}>
                    <Col span={6}>
                    <Form.Item label={ t('breeding_farms.type_animal') }>
                        <SelectAnimalType
                            value={animal.type_id as number}
                            onChange={(value: any) =>
                                handleTypeChange(animal.id, value as number)
                            }
                        />
                    </Form.Item>

                    </Col>
                    <Col span={6}>
                    <Form.Item label={ t('breeding_farms.breed') }>
                        <SelectAnimalBreed
                            value={animal.breed_id}
                            animalType={animal.type_id as number} 
                            onChange={(value: any) =>
                                handleBreedChange(animal.id, value as number)
                            }
                        />
                    </Form.Item>
                    </Col>
                    <Col span={6}>
                    <Form.Item label={ t('breeding_farms.quantity') }>
                        <InputNumber
                            min={1}
                            value={animal.count}
                            onChange={(value) =>
                                handleCountChange(animal.id, value as number)
                            }
                        />
                    </Form.Item>
                    </Col>
                    <Col span={6}>
                    
                    <div className="remove_animal" onClick={() => removeAnimal(animal.id)}>
                        { t('breeding_farms.remove_animal_type') }
                    </div>
                    </Col>
                </Row>
            ))}

            <div className="add_animal" onClick={addAnimal}>
                { t('breeding_farms.add_animal_type') }
            </div>
        </>
    );
}
